// client/src/pages/ShopPOS/utils/currency.ts
import { getShopOwnerCurrencySync } from "@/lib/auth";

// Símbolos de moneda por código
const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: "$",
  EUR: "€",
  CUP: "$",
  L: "L",
  MXN: "$",
};

// Obtener símbolo de moneda según la configuración del owner
export const getCurrencySymbol = (): string => {
  const currency = getShopOwnerCurrencySync();
  return CURRENCY_SYMBOLS[currency] || "$";
};

// Formatear monto con símbolo de moneda
export const formatMoney = (amount: number): string => {
  return `${getCurrencySymbol()}${amount.toFixed(2)}`;
};

// Formatear monto sin decimales
export const formatMoneyNoDecimals = (amount: number): string => {
  return `${getCurrencySymbol()}${Math.round(amount)}`;
};
